import { createContext, useContext, useState, useEffect, useCallback } from "react";

const Ctx = createContext(null);

export function WorkGuardProvider({ children }) {
  const [flags, setFlags] = useState({});
  const setWork = useCallback((key, busy) => {
    setFlags((f) => (!!f[key] === !!busy ? f : { ...f, [key]: !!busy }));
  }, []);
  const hasOpenWork = Object.values(flags).some(Boolean);

  useEffect(() => {
    const h = (e) => {
      if (hasOpenWork) { e.preventDefault(); e.returnValue = ""; return ""; }
    };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, [hasOpenWork]);

  return <Ctx.Provider value={{ setWork, hasOpenWork }}>{children}</Ctx.Provider>;
}

export const useWorkGuard = () => useContext(Ctx) || { setWork: () => {}, hasOpenWork: false };
